var ContactForm = function() {
	/*$(".ContactPage").find("input, textarea").on("focus", function(){
		$(this).addClass("has-text");
	});

	$("#contact-form").on("submit", function(e){
		e.preventDefault();

		grecaptcha.ready(function() {
		    grecaptcha.execute('6LenNhseAAAAAEblSluY11mTUvRVW8csNcmlCJET', {action: 'contact_form'}).then(function(token) {
		        $('#contact-form').prepend('<input type="hidden" name="token" value="' + token + '">');
		        $('#contact-form').prepend('<input type="hidden" name="action" value="contact_form">');
		    });;
		});

		$("#contact-form").off();
		$("#contact-form")[0].submit();
	});*/
};

module.exports = ContactForm;
